import './Profile.scss';

const Profile = () => {
  return (
    <section className="profile" />
  );
};

export default Profile;
